import { render, staticRenderFns } from "./Advise.vue?vue&type=template&id=77556a56&"
import script from "./Advise.vue?vue&type=script&lang=js&"
export * from "./Advise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports